import PropTypes from 'prop-types';

export const propTypes = {
  position: PropTypes.string.isRequired,
  selectedNodes: PropTypes.array.isRequired,
};
